module.exports = __webpack_public_path__ + "img/nodata.462615e9.png";